document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-quick-buy]');
  if (!btn) return;
  e.preventDefault();
  if (btn.disabled) return;

  var form = btn.closest('form');
  var id = form ? new FormData(form).get('id') : btn.getAttribute('data-variant-id');
  if (!id) return;

  var original = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = '…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function () {
      btn.disabled = false;
      btn.innerHTML = original;
      window.location.href = '/cart/' + id + ':1';
    });
});
